<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="saveAll" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-book-open-page-variant" 
        v-bind:show.sync="dialog"
        maxWidth="100%"
        :showRequiredFields="false"
        :showButton="false"
    >
        <template v-slot:form>
            <v-container fluid>
                    <v-alert
                        v-if="isBlockedByTerms"
                        type="warning"
                        dense
                        outlined
                        class="mb-4"
                        icon="mdi-file-document-alert-outline"
                    >
                        Assine o(s) termo(s) obrigatório(s) pendentes para liberar a edição das marcações.
                    </v-alert>

                    <v-card v-if="model.info_date" flat class="mb-4 pa-3 grey lighten-5 rounded-lg">
                        <v-row align="start" no-gutters>
                            <v-col cols="12" md="5" class="pr-md-4 mb-2 mb-md-0">
                                <span class="text-caption grey--text text--darken-2 d-block mb-1">Período</span>
                                <div class="font-weight-medium text-body-2">{{ formatPeriod(model) }}</div>
                            </v-col>
                            <v-col cols="12" md="7">
                                <span class="text-caption grey--text text--darken-2 d-block mb-1">Dias permitidos</span>
                                <div class="d-flex flex-wrap align-center" style="gap: 6px;">
                                    <template v-if="!hasAllowedDatesList(model.info_date)">
                                        <v-chip x-small color="grey lighten-3">Todos os dias</v-chip>
                                    </template>
                                    <template v-else>
                                        <v-chip
                                            v-for="(d, i) in formatAllowedDatesChips(model.info_date.allowed_dates)"
                                            :key="i"
                                            x-small
                                            outlined
                                            color="primary"
                                        >
                                            {{ d }}
                                        </v-chip>
                                        <span v-if="formatAllowedDatesRemaining(model.info_date.allowed_dates) > 0" class="text-caption grey--text">
                                            +{{ formatAllowedDatesRemaining(model.info_date.allowed_dates) }}
                                        </span>
                                    </template>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>

                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-progress-linear
                                v-if="loading"
                                indeterminate
                                color="primary"
                                class="mb-2"
                            />
                            <v-data-table
                                v-if="renderComponent"
                                :items="items"
                                :headers="headers.filter(h => h.visible)"
                                sort-by="calories"
                                class="elevation-1 cartao-ponto-table"
                                item-key="index"
                                :hide-default-footer="true"
                                :items-per-page="-1"
                                fixed-header
                                height="420"
                                dense
                            >
                                <template v-slot:header.check_in_1="{}">
                                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">E1</span></template><span>Entrada 1</span></v-tooltip>
                                </template>
                                <template v-slot:header.check_out_1="{}">
                                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">S1</span></template><span>Saída 1</span></v-tooltip>
                                </template>
                                <template v-slot:header.check_in_2="{}">
                                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">E2</span></template><span>Entrada 2</span></v-tooltip>
                                </template>
                                <template v-slot:header.check_out_2="{}">
                                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">S2</span></template><span>Saída 2</span></v-tooltip>
                                </template>
                                <template v-slot:header.check_in_3="{}">
                                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">E3</span></template><span>Entrada 3</span></v-tooltip>
                                </template>
                                <template v-slot:header.check_out_3="{}">
                                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">S3</span></template><span>Saída 3</span></v-tooltip>
                                </template>
                                <template v-slot:header.check_in_4="{}">
                                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">E4</span></template><span>Entrada 4</span></v-tooltip>
                                </template>
                                <template v-slot:header.check_out_4="{}">
                                    <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">S4</span></template><span>Saída 4</span></v-tooltip>
                                </template>
                                <template v-slot:top>
                                    <div class="d-flex align-center pa-2 flex-wrap">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-if="showAddItem"
                                                    class="ma-2"
                                                    color="primary"
                                                    :disabled="isBlockedByTerms"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="showRegisterOccurrenceItem({ occurrence_sheet_id: model.id, teacher_id: model.teacher_id }, -1, 1)"
                                                    depressed
                                                >
                                                    <v-icon left>mdi-plus</v-icon>
                                                    Adicionar Marcação
                                                </v-btn>
                                            </template>
                                            <span>{{ isBlockedByTerms ? 'Assine o(s) termo(s) obrigatório(s) pendentes para liberar a adição' : 'Adicionar Marcação' }}</span>
                                        </v-tooltip>
                                        <span class="text-caption grey--text ml-2">Registre os horários de entrada e saída de cada dia</span>
                                        <v-chip x-small outlined class="ml-2" color="grey">E=Entrada • S=Saída</v-chip>
                                    </div>
                                </template>

                                <template dense v-slot:item.date="{ item }">
                                    
                                    <!-- <emc-calendar-date-picker2
                                        :model.sync="item.date" 
                                        label="" 
                                        :error="errors.length > 0"
                                        :error-messages="errors['items.' + index + '.date']" 
                                        :show="dialog"
                                        :min="dateMin"
                                        :max="dateMax"
                                        :allowed-dates="allowedDates"
                                        dense
                                        :disabled="item.blocked ? true : false"
                                        fieldClass="mb-0 pb-0"
                                    /> -->

                                    {{ item.date | date }}

                                    <br/>

                                    <small class="mt-0 pt-0" v-html="getDescriptionJourney(item)" />
                                   
                                </template>

                                 <template dense v-slot:item.description="{ item }">
                                    
                                    {{ item.description }}
                                                                        
                                    <!-- <v-textarea
                                        class="mt-2"
                                        v-model="item.description"
                                        :error="errors.length > 0"  
                                        :error-messages="errors['items.' + index + '.description']"
                                        label=""
                                        rows="3"
                                        auto-grow
                                        outlined
                                       :disabled="item.blocked ? true : false"
                                    /> -->

                                </template>

                                <!-- Marcação 1 -->
                                <template dense v-slot:item.check_in_1="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :error-messages="errors.check_in_1" v-model="item.check_in_1" label="" :disabled="isItemBlocked(item)" />

                                </template>

                                <template dense v-slot:item.check_out_1="{ item }">

                                    <s-text-field  v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="isItemBlocked(item) || (!item.check_in_1 && !item.check_out_1)" :error-messages="errors.check_out_1" v-model="item.check_out_1" label="" />

                                </template>

                                <!-- Marcação 2 -->
                                <template dense v-slot:item.check_in_2="{ item }">

                                    <s-text-field  v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]"  :disabled="isItemBlocked(item) || (!item.check_out_1 && !item.check_in_2)" :error-messages="errors.check_in_2" v-model="item.check_in_2" label="" />

                                </template>

                                <template dense v-slot:item.check_out_2="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="isItemBlocked(item) || (!item.check_in_2 && !item.check_out_2)" :error-messages="errors.check_out_2" v-model="item.check_out_2" label="" />

                                </template>

                                 <!-- Marcação 3 -->
                                <template dense v-slot:item.check_in_3="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="isItemBlocked(item) || (!item.check_out_2 && !item.check_in_3)" :error-messages="errors.check_in_3" v-model="item.check_in_3" label="" />

                                </template>

                                <template dense v-slot:item.check_out_3="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="isItemBlocked(item) || (!item.check_in_3 && !item.check_out_3)" :error-messages="errors.check_out_3" v-model="item.check_out_3" label="" />

                                </template>

                                 <!-- Marcação 4 -->
                                <template dense v-slot:item.check_in_4="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="isItemBlocked(item) || (!item.check_out_3 && !item.check_in_4)" :error-messages="errors.check_in_4" v-model="item.check_in_4" label="" />

                                </template>

                                <template dense v-slot:item.check_out_4="{ item }">

                                    <s-text-field v-mask="'00:00'" clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="isItemBlocked(item) || (!item.check_in_4 && !item.check_out_4)" :error-messages="errors.check_out_4" v-model="item.check_out_4" label="" />

                                </template>


                                <template dense v-slot:item.type="{ item}">

                                    
                                    <span v-if="item.type">
                                        <emc-info-help v-if="item.note || item.motive" title="Justificativa">
                                            <template v-slot:text>
                                                
                                                <span v-if="item.motive">
                                                    {{ item.motive.name }}
                                                    <small v-if="item.note"></small>
                                                </span>
                                                <span v-else-if="item.note">
                                                    {{ item.note }}
                                                </span>
                                                
                                            </template>
                                        </emc-info-help>
                                        {{ item.type.name }}
                                    </span>
                                    
                                </template>

                                <!-- <template dense v-slot:item.occurrence_status_id="{ item, index }">
                                    <sys-select-occurrence-status
                                        :model.sync="item.occurrence_status_id"
                                        :error="errors.length > 0"  
                                        :errors="errors['items.' + index + '.occurrence_status_id']"
                                        label=""
                                    />
                                </template> -->

                                <template v-slot:item.actions="{ item, index }">

                                    <span>
                                        
                                        <emc-button-icon
                                            v-if="!hideEdit"
                                            :loading="index == indexItem && loadingUpdate"
                                            icon="mdi-content-save-outline"
                                            color="success"
                                            @click="updateItem(item, index)"
                                            :disabled="disabledActions || isItemBlocked(item)"
                                            :text="isItemBlocked(item) && isBlockedByTerms ? 'Assine o(s) termo(s) obrigatório(s) pendentes para liberar a edição' : 'Salvar Marcações'"
                                            text-button="Salvar"
                                        />

                                        <br/>
                                        <v-divider></v-divider>
                                        <emc-button-icon
                                            v-if="!hideDelete"
                                            :loading="index == indexItem && loadingDelete"
                                            icon="mdi-calendar-plus"
                                            color="primary"
                                            @click="showRegisterOccurrenceItem(item, index, 0)"
                                            :disabled="disabledActions || isItemBlocked(item)"
                                            :text="isItemBlocked(item) && isBlockedByTerms ? 'Assine o(s) termo(s) obrigatório(s) pendentes para liberar a edição' : 'Cadastrar Ocorrência'"
                                            text-button="Ocorrência"
                                        />
                                    </span>

                                    
                                </template>
                            
                            </v-data-table>
                        </v-col>
                    </v-row>
            </v-container>

            <emc-alert-modal 
                title="Justificativa de Alteração" 
                icon="mdi-text-box-edit-outline" 
                text="Informe o motivo da alteração nas marcações de ponto."
                :disabled="loadingUpdate" 
                v-bind:show.sync="showJustificationModal"
            >
                <template v-slot:content>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="justificationNote"
                                :label="'Justificativa (Mínimo ' + minNote + ' caracteres)'"
                                :counter="maxNote"
                                :rules="justificationRules"
                                outlined
                                rows="3"
                                auto-grow
                                placeholder="Informe o motivo da alteração..."
                            />
                        </v-col>
                    </v-row>
                </template>
                
                <template v-slot:actions>
                    <v-btn text @click="cancelJustification()">Cancelar</v-btn>
                    <v-btn 
                        color="primary" 
                        @click.prevent.stop="confirmJustification()" 
                        :loading="loadingUpdate" 
                        :disabled="!isJustificationValid"
                    >
                        Confirmar
                        <v-icon right dark>mdi-check</v-icon>
                    </v-btn>
                </template>
            </emc-alert-modal>

             <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>

            <sys-occurrence-teacher-register :new-item="newItem" @onCompleted="getData()" :allowedDates="allowedDates" :model="selectedOccurrenceItem" v-bind:show.sync="showFormRegisterItem" />

            
        </template>

       
       
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceSheetSheetTeacherItemRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        selectedOccurrenceType: null,
        selectedOccurrenceItem: {},
        showFormRegisterItem: false,
        showJustificationModal: false,
        justificationNote: null,
        pendingItem: null,
        pendingIndex: -1,
        originalRegisters: {},
        newItem: 0,
        occurrence_type_id: null,
        dateMin: null,
        dateMax: null,
        allowedDates: null,
        position: null,
        occurrence_sheet_register_motive_id: null,
        minNote: 5,
        maxNote: 255,
        note: null,
        indexItem: -1,
        disabledActions: false,
        items: [],
        loading: false,
        loadingUpdate: false,
        loadingDelete: false,
        renderComponent: true,
        markings: ['check_in_1', 'check_out_1', 'check_in_2', 'check_out_2', 'check_in_3', 'check_out_3' ],
        headers: [
            { text: 'Data',                value: 'date',                  align: 'start', sortable: false, visible: true, width: '11%' },
            { text: 'Descrição',           value: 'description',         align: 'start', sortable: false, visible: true, width: '22%' },
            { text: 'E1', value: 'check_in_1',  align: 'center', sortable: false, visible: true, width: '7%', class: 'col-entrada col-marcacao-1' },
            { text: 'S1', value: 'check_out_1', align: 'center', sortable: false, visible: true, width: '7%', class: 'col-saida col-marcacao-1' },
            { text: 'E2', value: 'check_in_2',  align: 'center', sortable: false, visible: true, width: '7%', class: 'col-entrada col-marcacao-2' },
            { text: 'S2', value: 'check_out_2', align: 'center', sortable: false, visible: true, width: '7%', class: 'col-saida col-marcacao-2' },
            { text: 'E3', value: 'check_in_3',  align: 'center', sortable: false, visible: true, width: '7%', class: 'col-entrada col-marcacao-3' },
            { text: 'S3', value: 'check_out_3', align: 'center', sortable: false, visible: true, width: '7%', class: 'col-saida col-marcacao-3' },
            { text: 'E4', value: 'check_in_4',  align: 'center', sortable: false, visible: true, width: '7%', class: 'col-entrada col-marcacao-4' },
            { text: 'S4', value: 'check_out_4', align: 'center', sortable: false, visible: true, width: '7%', class: 'col-saida col-marcacao-4' },
            { text: 'Ocorrência',          value: 'type',                  align: 'center', sortable: false, visible: true, width: '11%' },
            { text: 'Status',       value: 'occurrence_status_id',  align: 'center',sortable: false, visible: false, width: '10%'  },
            { text: '',             value: 'actions',               align: 'center',sortable: false, visible: true, width: '10%' },
        ],
    }),
    created(){

    },

    computed: {
      ...mapState('auth', ['acesso']),

      disabledSave(){
            
            let value = this.loadingDelete || this.note === null || this.note.length < this.minNote || this.note.length > this.maxNote || !this.occurrence_type_id;

            if(this.selectedOccurrenceType && this.selectedOccurrenceType.requires_motive){
                value = value || !this.occurrence_sheet_register_motive_id;
            }

            return value;

        },

      isJustificationValid() {
            return this.justificationNote && 
                   this.justificationNote.length >= this.minNote && 
                   this.justificationNote.length <= this.maxNote;
        },

      justificationRules() {
            return [
                v => !!v || 'Justificativa é obrigatória',
                v => (v && v.length >= this.minNote) || `Mínimo ${this.minNote} caracteres`,
                v => (v && v.length <= this.maxNote) || `Máximo ${this.maxNote} caracteres`
            ];
        },

    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;

            if(show_new){
                
                
                this.dateMin = this.model.info_date.start;
                this.dateMax = this.model.info_date.end;
                this.allowedDates = this.model.info_date.allowed_dates;

                this.error = false;
                this.errors = {};
                this.getData();
                this.getLocation();


            }
        },
        
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Marcações de Ponto"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        hideDelete: {
            type: Boolean,
            default: false
        },
        hideEdit: {
            type: Boolean,
            default: false
        },
        showAddItem: {
            type: Boolean,
            default: false
        },
        showEditMark: {
            type: Boolean,
            default: true
        },
        isBlockedByTerms: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('timeSheet', ['ActionIndexOccurrenceSheetItems', 'ActionUpdateOccurrenceSheet', 'ActionStoreOccurrenceSheetItem', 'ActionUpdateOccurrenceSheetItem', 'ActionDestroyOccurrenceSheetItem', 'ActionAbsenceRegisterSheetItem']),

        /**
         * Verifica se o item está bloqueado por uma ocorrência que impede alterações
         * ou por termos obrigatórios pendentes.
         * Considera o campo block_marks_on_register do tipo de ocorrência e isBlockedByTerms.
         */
        isItemBlocked(item) {
            if (this.isBlockedByTerms) {
                return true;
            }
            return !!(item.occurrence_type_id != null &&
                   item.type &&
                   item.type.block_marks_on_register);
        },

        /**
         * Verifica se há alterações nos horários de marcação do item.
         * Compara os valores atuais com os originais salvos.
         */
        hasTimeChanges(item) {
            const itemId = item.id || item.index;
            const original = this.originalRegisters[itemId];
            
            // Se não há registro original (item novo), considera que há alteração
            if (!original && item.id === 0) {
                // Verifica se há alguma marcação preenchida
                return this.markings.some(m => item[m]);
            }
            
            if (!original) {
                return false;
            }
            
            // Compara cada campo de marcação
            for (const mark of this.markings) {
                const currentValue = item[mark] || null;
                const originalValue = original[mark] || null;
                
                if (currentValue !== originalValue) {
                    return true;
                }
            }
            
            return false;
        },

        /**
         * Armazena os valores originais das marcações do item para comparação posterior.
         */
        storeOriginalRegisters(item) {
            const itemId = item.id || item.index;
            this.originalRegisters[itemId] = {};
            
            for (const mark of this.markings) {
                this.originalRegisters[itemId][mark] = item[mark] || null;
            }
        },

        /**
         * Cancela o modal de justificativa e restaura os valores originais.
         */
        cancelJustification() {
            this.showJustificationModal = false;
            this.justificationNote = null;
            
            // Restaurar valores originais do item pendente
            if (this.pendingItem) {
                const itemId = this.pendingItem.id || this.pendingItem.index;
                const original = this.originalRegisters[itemId];
                
                if (original) {
                    for (const mark of this.markings) {
                        this.pendingItem[mark] = original[mark];
                    }
                }
            }
            
            this.pendingItem = null;
            this.pendingIndex = -1;
        },

        /**
         * Confirma a justificativa e prossegue com a atualização do item.
         */
        confirmJustification() {
            if (!this.isJustificationValid) {
                return;
            }
            
            this.showJustificationModal = false;
            
            // Prosseguir com a atualização incluindo a justificativa
            this.executeUpdateItem(this.pendingItem, this.pendingIndex, this.justificationNote);
            
            this.justificationNote = null;
            this.pendingItem = null;
            this.pendingIndex = -1;
        },

        getData(){

                this.loading = true;
                this.items = [];
                this.showFormRegisterItem = false;

                var payload = {
                    find_columns: {
                        occurrence_sheet_id: this.model.id,
                    },
                    select: 'info_date',
                    with: 'registers,type,motive',
                }

                this.ActionIndexOccurrenceSheetItems(payload)
                    .then((res) => {
                        this.items = res.data;
                    })
                    .finally(() => {
                        this.loading = false;
                        this.loadMarks();
                    });

        },

        changeType(ev){
            this.selectedOccurrenceType = ev;
            this.occurrence_sheet_register_motive_id = null;
        },  

        getDescriptionJourney(item)
        {
            
            let description = '';
            
            for (let index = 1; index <= 6; index++) {
                
                let start = 'hour_start' + index;
                let end = 'hour_end' + index;
                
                if(!item[start] &&  !item[end]){
                    continue;
                }
                
                if(description != ''){
                    description += '<br/>';
                }

                if(item[start]){
                    description += item[start].substring(0, 5);
                }

                if(item[end]){
                    description += ' - ' + item[end].substring(0, 5);
                }
                
            }
            
            return description;
        },

        formatPeriod(model) {
            if (!model || !model.info_date) return '—';
            const start = model.info_date.start;
            const end = model.info_date.end;
            if (!start || !end) return '—';
            return `${this.$options.filters.date(start)} a ${this.$options.filters.date(end)}`;
        },
        hasAllowedDatesList(infoDate) {
            const d = infoDate && infoDate.allowed_dates;
            return Array.isArray(d) && d.length > 0;
        },
        formatAllowedDatesChips(dates) {
            const arr = Array.isArray(dates) ? dates : (typeof dates === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dates) ? [dates] : []);
            if (!arr.length) return [];
            const maxChips = 6;
            return arr.slice(0, maxChips).map(d => this.$options.filters.date(d)).filter(Boolean);
        },
        formatAllowedDatesRemaining(dates) {
            const arr = Array.isArray(dates) ? dates : (typeof dates === 'string' ? [dates] : []);
            const maxChips = 6;
            return Math.max(0, arr.length - maxChips);
        },

        getLocation()
        {
            if (navigator.geolocation)
            {
                navigator.geolocation.getCurrentPosition((pos) => {
                    
                    this.position = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude
                    };
                });
            }
            
        },

        loadMarks(){

            this.originalRegisters = {};

            this.items.forEach(item => {
                
                let index = 0;
                
                for (let i = 0; i < item.registers.length; i++) {
                    
                    let reg = item.registers[i];
                    
                    if(reg.action == 'I' || reg.action == 'U'){
                        item[this.markings[index++]] = reg.time;
                    }
                }

                // Armazenar os valores originais após carregar as marcações
                this.storeOriginalRegisters(item);
            });

        },
        
        saveAll(){
            
            this.loading = true;
            this.error = false;
            this.errors = {};

            this.items.forEach(item => {
                this.loadRegisters(item);
            });
            
            this.ActionUpdateOccurrenceSheet(this.model)
                .then((res) => {
                    item.id = res.data.id;
                    item.registers = res.data.registers;
                })
                .catch((error) =>{
                    this.error = true;
                    this.errors = error.errors;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        removeItem(item){
          var index = this.items.indexOf(item);
          this.items.splice(index, 1);
          this.showFormRegisterItem = false;
          this.forceRerender();
        },

        updateItem(item, index){
          if (this.isBlockedByTerms) {
            return;
          }
          // Verificar se há alterações nas marcações
          if (this.hasTimeChanges(item)) {
              // Exibir modal de justificativa
              this.pendingItem = item;
              this.pendingIndex = index;
              this.justificationNote = null;
              this.showJustificationModal = true;
              return;
          }
          
          // Se não há alterações, prosseguir normalmente
          this.executeUpdateItem(item, index, null);
            
      },

      /**
       * Executa a atualização do item com a justificativa fornecida.
       */
      executeUpdateItem(item, index, justificationNote){
          if (this.isBlockedByTerms) {
            return;
          }
          var method = item.id ? 'ActionUpdateOccurrenceSheetItem' : 'ActionStoreOccurrenceSheetItem';
          this.loadingUpdate = true;
          this.indexItem = index;
          this.message = '';
          this.error = false;
          this.errors = {};
            
          this.loadRegisters(item, justificationNote);

          this[method](item)
            .then((res) => {
                
                item.id = res.data.id;
                item.registers = res.data.registers;
                this.message = "Marcação atualizada com sucesso";
                // Atualizar os registros originais após salvar com sucesso
                this.storeOriginalRegisters(item);

            })
            .catch((error) =>{
                
                Object.keys(error.errors).forEach(key => {
                    this.errors['items.' + index + '.' + key] = error.errors[key];
                });

                this.error = true;
                this.message = error.message;
            })
            .finally(() => {
                  this.loadingUpdate = false;
                  this.indexItem = -1;
                  //this.forceRerender();
            });
            
      },

      loadRegisters(item, justificationNote = null){

        let registersOriginal = item.registers;
        let registers = [];
        const itemId = item.id || item.index;
        const original = this.originalRegisters[itemId] || {};
        
        for (let i = 0; i < this.markings.length; i++) {
                
                let date    = item.date;
                let time    = item[this.markings[i]];
                let mark    = this.markings[i];
                
                if(time){

                    let reg = registersOriginal.find(r => (r.time == time && r.date == date));

                    if(reg){
                        // Verificar se houve alteração para adicionar justificativa
                        let registerData = { ...reg };
                        
                        if (justificationNote && original[mark] !== time) {
                            registerData.note = justificationNote;
                        }
                        
                        registers.push(registerData);
                    }else{
                        registers.push({
                            id:                                 0,
                            occurrence_sheet_item_id:           item.id,
                            occurrence_intervention_type_id:    1, // 2 = Incluído | 4 = Exceção
                            date:                               date,
                            time:                               time,
                            localization:                       this.position ? (this.position.lat + ';' + this.position.lng) : null,
                            note:                               justificationNote, // Adicionar justificativa para novos registros
                        });
                    }

                }

            }

            item.registers = registers;
      },

      showRegisterOccurrenceItem(item, index, newItem)
      {
        if (this.isBlockedByTerms) {
          return;
        }
        this.selectedOccurrenceItem = item;
        this.indexItem = index;
        this.newItem = newItem;
        this.showFormRegisterItem = true;
           
      },

      deleteItem(){
          
          let item = this.selectedOccurrenceItem;
          
          if(!item.id){
            this.removeItem(item);
            return;
          }
          
          this.loadingDelete = true;
          this.error = false;
          this.errors = {};
          let payload = {
            id: item.id,
          };
          
          this.ActionDestroyOccurrenceSheetItem(payload)
            .then((res) => {
                this.removeItem(item);
            })
            .catch((error) =>{
                
                
            })
            .finally(() => {
                  this.loadingDelete = false;
                  this.indexItem = -1;
                  this.showFormRegisterItem = false;
                  this.selectedOccurrenceItem = {};
                  this.forceRerender();
            });
            
      },

      absenceItem(){
          
          let item = this.selectedOccurrenceItem;
          
          this.loadingDelete = true;
          this.error = false;
          this.errors = {};
          let payload = {
            id: item.id,
            note: this.note,
            occurrence_type_id: this.occurrence_type_id,
            occurrence_sheet_register_motive_id: this.occurrence_sheet_register_motive_id,
          };
          
          this.ActionAbsenceRegisterSheetItem(payload)
            .then((res) => {
                
            })
            .catch((error) =>{
                
                
            })
            .finally(() => {
                  this.loadingDelete = false;
                  this.indexItem = -1;
                  this.showFormRegisterItem = false;
                  this.selectedOccurrenceItem = {};
                  this.getData();
            });
      },

      addItem(){
          
          if(!this.model){
            return;
          }

          var length = this.items.length;
          
          var item = {
              index:                        length,
              id:                           0,
              occurrence_sheet_id:          this.model.id,
              occurrence_record_type_id:    1,
              occurrence_type_id:           null,
              occurrence_sheet_register_motive_id: null,
              occurrence_status_id:         1,
              date:                         null,
              hour_start1:                  null,
              hour_end1:                    null,
              hour_start2:                  null,
              hour_end2:                    null,
              hour_start3:                  null,
              hour_end3:                    null,
              description:                  null,
              registers:                    [],
          };

          this.items.unshift(item);
          this.forceRerender();
          
      },

    validateTime(value) {
        
        if (!value) return true // Se vazio, sem erro
        if (value.length === 0) return true // sem erro se vazio
        if (value.length < 5) return true   // ainda digitando, não valida
        
        const regex = /^([01]\d|2[0-3]):([0-5]\d)$/
        return ( regex.test(value)) || 'Hora inválida. Use o formato HH:MM (00:00 a 23:59)'
    },

      forceRerender () {
      
        this.renderComponent = false;

        this.$nextTick(() => {
            this.renderComponent = true;
        });
    }

      

    }
}
</script>

<style scoped>
.cartao-ponto-table >>> tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, 0.02);
}
.cartao-ponto-table >>> tbody tr:hover {
    background-color: rgba(25, 118, 210, 0.04) !important;
}
.cartao-ponto-table >>> .v-data-table__wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.cartao-ponto-table >>> table {
    min-width: 800px;
}
.cartao-ponto-table >>> th.col-entrada {
    background-color: rgba(76, 175, 80, 0.08) !important;
}
.cartao-ponto-table >>> th.col-saida {
    background-color: rgba(244, 67, 54, 0.06) !important;
}
.cartao-ponto-table >>> th.col-marcacao-1,
.cartao-ponto-table >>> th.col-marcacao-2,
.cartao-ponto-table >>> th.col-marcacao-3 {
    border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.cartao-ponto-table >>> td:nth-child(5),
.cartao-ponto-table >>> td:nth-child(7),
.cartao-ponto-table >>> td:nth-child(9) {
    border-left: 1px solid rgba(0, 0, 0, 0.06);
}
</style>